import React from "react";
import "../login/styles/login.css";
import "./styles/signup.css";
import SignupCard from "./components/SignupCard";

function SignUpMain() {
  return (
    <section className="auth-main-page d-flex align-items-center justify-content-center">
      <SignupCard />
    </section>
  );
}

export default SignUpMain;
